import React, { useState } from 'react';
import './Login.css';
import { useDispatch } from 'react-redux';
import { setTokens } from '../../store/tokensSlice';
import ApiService from '../api_services/apiService.jsx';

const allowedRoles = ['[ADMIN]', '[USER]'];

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await ApiService.post('/api/auth/login', {
        login: username,
        pass: password,
      });

      if (response.data && allowedRoles.includes(response.data.userRole)) {
        dispatch(
          setTokens({
            accessToken: response.data.accessToken,
            refreshToken: response.data.refreshToken,
            userEmail: response.data.userEmail,
            userPhoneNumber: response.data.userPhoneNumber,
            accessTokenExpiration: response.data.accessTokenExpiresAt,
            refreshTokenExpiration: response.data.refreshTokenExpiresAt,
            userRole: response.data.userRole,
          })
        );
      } else if (response.data) {
        alert('Nie masz dostępu do tego panelu.');
      } else {
        alert('Nieprawidłowa odpowiedź serwera.');
      }
    } catch (error) {
      console.error('Login error:', error);
      alert('Logowanie nie powiodło się. Sprawdź dane.');
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h1 className="login-title">WamaGold</h1>
        <p className="login-subtitle">Panel systemowy</p>
        <p className="login-instruction">Wprowadź dane, aby się zalogować</p>
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Login</label>
            <input
              type="text"
              id="username"
              placeholder="Wpisz login"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Hasło</label>
            <input
              type="password"
              id="password"
              placeholder="Wpisz hasło"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="login-button">
            Zaloguj się
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
